import { dispatch } from '@shared/utils/saga';

export const GO_TO_ROUTE_ACTION = 'SAGA_ROUTER/GO_TO_ROUTE';
export const SAGA_ROUTER_READY = 'SAGA_ROUTER/READY';

export function* goToRoute(path: string, force?: boolean) {
  if (force) {
    window.location.href = path;
    return;
  }
  yield dispatch({ type: GO_TO_ROUTE_ACTION, payload: path });
}
